import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import ToggleSwitch from '@bibliocommons/deprecated-base-toggle-switch';
import { routerShape } from '@bibliocommons/bc-prop-types';
import { PushPin } from '@bibliocommons/deprecated-base-icons';
import ImmutablePropTypes from 'react-immutable-proptypes';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

import './ActiveFilterLockSwitch.scss';

export class ActiveFilterLockSwitch extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilterLock() {
    const { router, active, activeFilters, searchType } = this.props;

    const query = updateSearchQuery({
      currentQuery: router.query,
      activeFilters,
      searchType,
      locked: active ? undefined : 'true'
    });

    router.push({ query });
  }

  render() {
    const { active } = this.props;
    return (
      <ToggleSwitch
        className="cp-active-filter-lock-switch"
        active={active}
        activeLocaleKey="active_filters_locked"
        inactiveLocaleKey="active_filters_unlocked"
        handleClick={this.handleToggleFilterLock}
      >
        <PushPin className="small" />
      </ToggleSwitch>
    );
  }
}

ActiveFilterLockSwitch.displayName = 'ActiveFilterLockSwitch';
ActiveFilterLockSwitch.propTypes = {
  active: PropTypes.bool.isRequired,
  activeFilters: ImmutablePropTypes.map,
  searchType: PropTypes.string,
  router: routerShape.isRequired
};

export default withRouter(ActiveFilterLockSwitch);
